import effectManager from '../module/effect';

let effect = new effectManager();

/* ---------------------------------------

    -- ローダーのアニメーション

--------------------------------------- */
export default class  LoaderManager {
    constructor() {
        this.$contaner =  $("#l-loader");
        this.$progress =  this.$contaner.find(".js__loader-svg-write");

        this.flg = false;
    }
    init(){
        TweenLite.set($(".js__loader-svg-write"), {drawSVG: "0%"});
    }
    render(){

        let _parsent = Number($(".pace-progress").attr("data-progress"));
        TweenLite.set(this.$progress, {drawSVG: _parsent+"%"});
        if(_parsent>=99){
            this.flg = true;
            TweenLite.to(this.$progress,0.2,{drawSVG: 100+"%"});
            setTimeout(()=>{
                this.$contaner.addClass("is-done")
                TweenMax.staggerTo($(".js__loader-svg-out"), 0.6, {
                    drawSVG: "0%",
                    ease: Expo.easeOut,
                }, .01);
                effect.cover($("#l-loader-bg .js__loader-bg"),"out");
                setTimeout(()=>TweenMax.to(this.$contaner,0.2,{opacity: 0}),1e3)
            },5e2);
        }

    }
}